export default __webpack_public_path__ + "static/media/browser.29fed8b9.svg";